// const eth_flag = String.fromCodePoint(0x1F1EA, 0x1F1F9);
// const laugh_laugh_emoji = String.fromCodePoint(`&#128514;`);
export const CodeInfo = `#!/usr/bin/env python3
class Makuochukwu(Okeke, Angela):
    """Trying to create a copy of 'myself'... I mean my metadata :)"""
    def __init__(self):
        """Create self and inherit characters
        from parent objects..oops they are humans not objects :)"""
        # wondering what Okeke and Angela are?
        # have a look at the following two lines
        print(type(Okeke)) # <class 'Dad'> 
        print(type(Angela)) # <class 'Mom'> 

        super(Angela, self).__init__() # inheriting love from my mom
        super(Okeke, self).__init__() #inheriting deligent character from dad
        self.full_name = "Makuochukwu Christian Okeke"
        self.age = 22
        self.marital_status = "Married with *.py :)"
        self.interest = ["Tech", "Entrepreneurship", "Leadership" "Learning"]
        self.values = ["Integrity", "Empathy", "Creativity", "Faith", "Love"]
        self.favorite_food = "Nigeria Jollof"

        self.fun_fact = """I'm obsessed with cockpit-camera footage of
                             an airplane landing and taking off. 
                            I have watched it over 100 times. If you are a 
                            pilot, please give me just one chance to to be with 
                            you in the cabin for some time :). May be I should
                            switch my job to become a pilot :)"""

    def driver(self):
        # principle that self follows for moving forward
        while alive:
            try:
                self.learn()
                self.practice()
                self.repeat()
            except:
                self.driver()
            finally:
                self.learn_from_failure()
                self.relearn()
        `;
